/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button[_ngcontent-%COMP%]{position:absolute;font-size:14px;min-width:0;right:7px;bottom:-3px;height:27px}textarea[_ngcontent-%COMP%]{resize:none}"];
export { styles as styles };
